import { useParams} from "react-router-dom";
import { useEffect, useState } from "react";
import { Header } from "../../components/Header";
import { toast } from "react-toastify"
import api  from "../../services/api";
import './filme.css'



export const Filme = ()=> {

  const { id } = useParams();
  const [filmes, setFilmes] = useState([]);
  const [loading, setLoading] = useState(true)

  useEffect(()=>{

    async function loadFilmes(){
      const response = await api.get(`r-api/?api=filmes/${id}`)
      console.log(response.data)
      setFilmes(response.data)
      setLoading(false)
    }

    loadFilmes();

  },[id]);

  function handleSave(){
    
    const minhaLista = localStorage.getItem('filmes');

    let filmesSalvos = JSON.parse(minhaLista) || [];

    //verificando a lista de filme para nao duplicar na hora de add outro
    const hasFilme = filmesSalvos.some( (filmeSalvo) => filmeSalvo.id === filmes.id)

    if(hasFilme){
      toast.info('Você ja possui esse filme salvo')
      return
    }

    filmesSalvos.push(filmes);
    localStorage.setItem('filmes', JSON.stringify(filmesSalvos));
    toast.success('Filme salvo com sucesso!')
  }



  if(loading){
    return(
      <div>
        <Header></Header>
        <h1>Carregando seu filme</h1>
      </div>
    ) 
  }
  return (
    <div>
        <Header></Header>
        <div className="container container-filme">
            <div className="lista">
              <div className="dados">
                <h1 className="titulo">{filmes.nome}</h1>
                <img className="capa" src={filmes.foto} alt={filmes.nome} />
                <p className="sinopse">{filmes.sinopse}</p>
              </div>
              <div className="botoes">
                <button onClick={handleSave}>Salvar</button>
                <button>
                  <a className="trailer" href={`https://youtube.com/results?search_query=${filmes.nome} Trailer`}
                  target="_blank"
                  rel="noopener noreferrer">Trailer
                  </a>
                </button>
              </div>
            </div>
        </div>
    </div>
  );
}


